import { BackDropSpinnerProvider, GlobalStyle } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router-dom';

function ShellContainer() {
  return (
    <>
      <GlobalStyle />
      <BackDropSpinnerProvider>
        <Outlet />
      </BackDropSpinnerProvider>
    </>
  );
}

export { ShellContainer };
